import "./flagAndCode.scss";
import Typography from "../../../Typography";

const CountryFlagAndCode = ({ flag, code }) => {
  return (
    <div className="country-flag-code">
      <img
        src={flag}
        width="16px"
        height="16px"
        alt="flag-icon"
        className="flag"
      />
      <Typography customClass="code" size="text-md" weight="regular">
        {code}
      </Typography>
      <hr />
    </div>
  );
};

export default CountryFlagAndCode;
